import list from '@/modules/CA_SP/mixins/asset_list.js';
import in_asset_class from '@/components/inputs/asset_class.vue';
export default {
  mixins: [list],
  data() {
    return {
			done:false,
			cantReviewDialog:false,
			error:'',
			selectedItem_id:null,
		};
	},
	components: { in_asset_class },
  computed: {
		canReviewThis(){ return this.can_review(this.selectedItem) },
		gettedWorkflowNull() {return this.$store.getters.getWorkflowNull},
	},
	created(){
		const {id} = this.$route.params;
		if (id) this.requests.get[`${this.asset_type}/a`](id)
			.then(r => {
				if(r.id) {
					if (![null, 0].includes(r.state)) {
						this.error = 'El asset no se encuentra en estado de revisión';
						this.cantReviewDialog = true;
						return
					}
					/* r.workflow = [];
					this.set_wf(r); */
					this.selectedItem = r;
					this.selectedItem_id = this.selectedItem.id
				}
				else this.error = 'No se encontro el asset';
			})
			.catch(e => this.error = 'No se encontro el asset' && this.getError(e))
		else this.error = 'No ha proporsionado los datos necesarios para encontrar el asset';
	},
	methods: {
		goToHome(){ this.$router.push({ name: 'home'}) },
	}
};